// extracted by mini-css-extract-plugin
module.exports = {"items":"nav-module--items--18JDU","initialBrandLogo":"nav-module--initialBrandLogo--kXYIS","hamburgerIcon":"nav-module--hamburgerIcon--VQ-aV"};